<div *ngIf="loading$ | async" class="overlay">
  <div class="spinner"></div>
</div>
